import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { IPlatform } from '../model/platform';
import { ICert } from "../model/cert";
import { SpinnerService } from './spinner.service';

@Injectable()
export class PlatformCertService {

  private platformCertUrl = environment.apiUrl + '/v1/invoicing-services/';

  constructor(private http: HttpClient,
              private spinnerService: SpinnerService) { }

  /**
   * @param {IPlatform} platform
   * @param {number} index
   * @returns {Observable<any | any>}
   */
  deletePlatformCert(identifier: string, platform: IPlatform, index: number) {
    const url = this.platformCertUrl + `${identifier}/platforms/${platform.id}/certificate/${platform.platformCerts[index].certificate.id}`;
    return this.http.delete(url)
      .map(res => res);
  }

  /**
   * @param {IPlatform} platform
   * @param {ICert} certificate
   * @returns {Observable<any | any>}
   */
  addCertificate(identifier: string, platform: IPlatform, certificate: ICert) {
    const url = this.platformCertUrl + `${identifier}/platforms/${platform.id}/certificate`;
    this.spinnerService.setSpinner(true);
    return this.http.post(url, certificate)
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res as IPlatform[];
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/platform-cert.service.ts